module.exports = __webpack_public_path__ + "img/Takari Kokoh Sejahtera.b8b619c9.png";